import { ElementType } from '../../../_objects/report-element';

export class PreviewControllerOfSection {
  private readonly textIds: Array<string>;
  private readonly lineIds: Array<string>;
  private readonly imageIds: Array<string>;
  private readonly rectangleIds: Array<string>;
  private readonly summaryIds: Array<string>;
  private readonly pictureIds: Array<string>;
  private readonly dataPlateIds: Array<string>;
  private readonly measurementPointIds: Array<string>;
  private readonly visualEventsIds: Array<string>;
  private readonly signatureIds: Array<string>;
  private readonly sectionIds: Array<string>;
  private readonly tableIds: Array<string>;
  private readonly interctiveIsoIds: Array<string>;
  private readonly dropDownListIds: Array<string>;
  private readonly customElementIds: Array<string>;

  constructor() {
    this.textIds = new Array<string>();
    this.lineIds = new Array<string>();
    this.imageIds = new Array<string>();
    this.rectangleIds = new Array<string>();
    this.summaryIds = new Array<string>();
    this.pictureIds = new Array<string>();
    this.dataPlateIds = new Array<string>();
    this.measurementPointIds = new Array<string>();
    this.visualEventsIds = new Array<string>();
    this.signatureIds = new Array<string>();
    this.sectionIds = new Array<string>();
    this.tableIds = new Array<string>();
    this.interctiveIsoIds = new Array<string>();
    this.dropDownListIds = new Array<string>();
    this.customElementIds = new Array<string>();
  }

  public getIds(type: ElementType): Array<string> {
    return this.getCore(type);
  }

  public previewElementsIds(): string[] {
    const text = this.getCore('Text');
    const line = this.getCore('Line');
    const image = this.getCore('Image');
    const rectangle = this.getCore('Rectangle');
    const summary = this.getCore('Summary');
    const picture = this.getCore('Picture');
    const dataPlate = this.getCore('DataPlate');
    const measurementPoint = this.getCore('MeasurementPoint');
    const visualEvents = this.getCore('VisualEvents');
    const signature = this.getCore('Signature');
    const section = this.getCore('Section');
    const table = this.getCore('Table');
    const interactiveIso = this.getCore('InteractiveIso');
    const dropDownList = this.getCore('DropDownList');
    const customElement = this.getCore('CustomElement');
    return text.concat(line, image, rectangle, summary, picture, dataPlate, measurementPoint, visualEvents, signature,
      section, table, interactiveIso, dropDownList, customElement);
  }

  public draw(type: ElementType, id: string | Array<string>): void;
  public draw(type: ElementType, id: any): void {

    const typeOf = Object.prototype.toString;
    const ids: Array<string> = (typeOf.call(id) === '[object Array]') ? id : [id];

    ids.forEach((key: string) => {
      if (this.getCore(type).indexOf(key) === -1) {
        this.getCore(type).push(key);
      } else {
        // console.log('this key is already exist. key: %s', key);
      }
    });
  }

  public remove(id: string | Array<string>): void;
  public remove(id: any): void {
    const worker = function (target: Array<string>, elementId: any) {
      let result = 0;
      const typeOf = Object.prototype.toString;
      const ids: Array<string> = typeOf.call(elementId) === '[object Array]' ? elementId : [elementId];

      ids.forEach((key: string, index: number) => {
        while (result !== -1) {
          result = target.indexOf(key);
          if (result !== -1) {
            target.splice(result, 1);
          }
        }
      });
    };

    worker(this.textIds, id);
    worker(this.lineIds, id);
    worker(this.imageIds, id);
    worker(this.rectangleIds, id);
    worker(this.summaryIds, id);
    worker(this.pictureIds, id);
    worker(this.dataPlateIds, id);
    worker(this.measurementPointIds, id);
    worker(this.visualEventsIds, id);
    worker(this.signatureIds, id);
    worker(this.sectionIds, id);
    worker(this.tableIds, id);
    worker(this.interctiveIsoIds, id);
    worker(this.dropDownListIds, id);
    worker(this.customElementIds, id);
  }

  public removeAll(type: ElementType): void {
    const length = this.getCore(type).length;
    this.getCore(type).splice(0, length);
  }

  private getCore(type: ElementType): Array<string> {
    let rtnArray: Array<string>;
    switch (type) {
      case ElementType.Text:
        rtnArray = this.textIds;
        break;
      case ElementType.Line:
        rtnArray = this.lineIds;
        break;
      case ElementType.Image:
        rtnArray = this.imageIds;
        break;
      case ElementType.Rectangle:
        rtnArray = this.rectangleIds;
        break;
      case ElementType.Summary:
        rtnArray = this.summaryIds;
        break;
      case ElementType.Picture:
        rtnArray = this.pictureIds;
        break;
      case ElementType.DataPlate:
        rtnArray = this.dataPlateIds;
        break;
      case ElementType.MeasurementPoint:
        rtnArray = this.measurementPointIds;
        break;
      case ElementType.VisualEvents:
        rtnArray = this.visualEventsIds;
        break;
      case ElementType.Signature:
        rtnArray = this.signatureIds;
        break;
      case ElementType.Section:
        rtnArray = this.sectionIds;
        break;
      case ElementType.Table:
        rtnArray = this.tableIds;
        break;
      case ElementType.InteractiveIso:
        rtnArray = this.interctiveIsoIds;
        break;
      case ElementType.DropDownList:
        rtnArray = this.dropDownListIds;
        break;
      case ElementType.CustomElement:
        rtnArray = this.customElementIds;
        break;
      default:
        // NOP
        break;
    }
    return rtnArray;
  }
}
